import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeader = ({ index, label, title, className = "" }) => (
  <Reveal className={`mb-12 sm:mb-16 ${className}`}>
    <div className="flex items-center gap-4 mb-5">
      <span className="section-label" data-testid={`section-index-${index}`}>
        {index} /
      </span>
      <span className="h-px w-10 bg-[#CCFF00]/60" />
      <span className="text-xs uppercase tracking-[0.3em] text-zinc-500 font-mono2">
        {label}
      </span>
    </div>
    <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tight text-white">
      {title}
    </h2>
  </Reveal>
);
